export enum ICardViewMode {
  Bundles = "bundles",
  Singles = "singles",
  MyCollections = "mycollections",
  Mobile = "mobile",
}
